import { ColorOptions, numberValidation, required } from '@jfs/ui-new'
import { TextInputNew } from '../../components/AdminInputs'
import * as Yup from 'yup'
import { Dropdown } from '../../components/Dropdown'
import { integrationMethods } from '../../utils/constants'

const optionalOrMaxFifty = Yup.string()
  .max(50, 'Max allowed length is 50')
  .matches(/(^$)|(^[a-zA-Z0-9]+$)/, 'Only alphanumeric chars allowed')

const textinputStyle = {
  type: 'body14',
  borderColor: '#d1d3e2' as ColorOptions,
  labelPaddingBottom: 8,
  borderRadius: 4,
  labelFontFamily: 'jiotype-bold',
  fontFamily: 'jiotype-medium',
  labelColor: '#6e707e' as ColorOptions,
  labelFontSize: 12,
  fontSize: 14,
  selectionColor: 'BLUE',
  paddingHorizontal: 8,
  color: '#6e707e' as ColorOptions,
  paddingVertical: 8,
  focusBorderColor: '#d1d3e2' as ColorOptions,
  borderWidth: 2,
  onFocusBorderWidth: 2,
}

export const formData: any = (
  id: string,
  addMerchant: (values: any) => void,
  updateMerchant: (values: any) => void,
  entityIdMap: any,
  isEditable: boolean,
  message: string,
) => [
  {
    formItems: [
      {
        horizontalComps: [
          {
            fieldName: 'processingEntityId',
            ComponentName: TextInputNew,
            label: 'Processing Entity Id',
            placeholder: 'Processing Entity Id',
            validationSchema: numberValidation,
            editable: isEditable,
            ...textinputStyle,
          },
          {
            fieldName: 'credentials',
            ComponentName: TextInputNew,
            label: 'Credentials',
            placeholder: 'Credentials',
            validationSchema: required,
            editable: isEditable,
            ...textinputStyle,
          },
          {
            fieldName: 'endpoint',
            ComponentName: TextInputNew,
            label: 'Endpoint',
            placeholder: 'Endpoint',
            validationSchema: required,
            editable: isEditable,
            ...textinputStyle,
          },
          {
            fieldName: 'integrationMethod',
            ComponentName: Dropdown,
            title: 'Integration Method',
            label: 'Integration Method',
            validationSchema: required,
            data: [...integrationMethods],
          },
          {
            fieldName: 'name',
            ComponentName: TextInputNew,
            label: 'Name',
            placeholder: 'Name',
            editable: isEditable,
            ...textinputStyle,
          },
        ],
      },
    ],
    horizontalFlex: 1,
    onSubmit: async (values: any) => {
      if (id) {
        updateMerchant(values)
      } else {
        addMerchant(values)
      }
      return 'end'
    },
    actionTitle: 'Add Mapping',
  },
]
